import React from "react";

export default function PaymentVerifiedIcon({ verified }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.096"
      height="20.2"
      viewBox="0 0 23.096 20.2"
    >
      <g id="Group_376" data-name="Group 376" transform="translate(0 0.001)">
        <path
          id="Path_743"
          data-name="Path 743"
          d="M-423.58,222.7h-.235q-4.971,0-9.942,0c-.186,0-.234-.041-.232-.23.012-.842,0-1.683.005-2.525a1.461,1.461,0,0,1,1.589-1.579q4.148,0,8.3,0c.172,0,.223.037.221.217a22.5,22.5,0,0,0,.083,2.815C-423.743,221.831-423.666,222.259-423.58,222.7Z"
          transform="translate(433.989 -214.049)"
          fill={verified ? "#008DD8" : "#c5c5c5"}
        />
        <path
          id="Path_744"
          data-name="Path 744"
          d="M-411.036,346.234a9.36,9.36,0,0,1-.794,1.008,15.055,15.055,0,0,1-3.732,2.872,2.112,2.112,0,0,1-1.566.233,3.723,3.723,0,0,1-1.106-.541,12.621,12.621,0,0,1-4.039-3.629.247.247,0,0,0-.247-.1q-5.625,0-11.249,0c-.164,0-.192.048-.192.2.005,2.315,0,4.629,0,6.944a1.443,1.443,0,0,0,1.513,1.519q10.032,0,20.063,0a1.6,1.6,0,0,0,.718-.16,1.569,1.569,0,0,0,.8-1.058v-7.442C-410.972,346.074-410.993,346.171-411.036,346.234Zm-16.517,4.169c-.458,0-.917,0-1.375,0-.443,0-.887,0-1.33,0a.732.732,0,0,1-.811-.716.728.728,0,0,1,.8-.726q1.364,0,2.728,0a.728.728,0,0,1,.8.726A.732.732,0,0,1-427.553,350.4Z"
          transform="translate(433.961 -334.535)"
          fill={verified ? "#008DD8" : "#c5c5c5"}
          opacity="0.96"
        />
        <path
          id="Path_745"
          data-name="Path 745"
          d="M-218.162,144.678a.869.869,0,0,0-.49-.55q-2.48-1.056-4.955-2.123a.794.794,0,0,0-.673.007c-.287.129-.578.247-.867.371q-2,.858-4.006,1.714a.755.755,0,0,0-.55.719,37.176,37.176,0,0,0,.129,4.749,7.581,7.581,0,0,0,1.894,4.1,13.691,13.691,0,0,0,3.362,2.581.75.75,0,0,0,.81-.023,17.032,17.032,0,0,0,2.385-1.649,7.782,7.782,0,0,0,2.839-5.08,3.035,3.035,0,0,1,.123-.759v-.18c-.034-.033-.02-.076-.023-.115s0-.1,0-.155-.021-.125.023-.181Zm-3.054,2.758c-.392.512-.8,1.011-1.207,1.515l-1.591,1.987a.738.738,0,0,1-1.31-.051c-.455-.679-.912-1.357-1.358-2.042a.716.716,0,0,1,.421-1.122.714.714,0,0,1,.778.324c.254.371.5.749.751,1.122.041.06.065.137.148.174.726-.907,1.455-1.814,2.177-2.725a.76.76,0,0,1,.754-.347A.713.713,0,0,1-221.216,147.435Z"
          transform="translate(241.257 -141.933)"
          fill={verified ? "#008DD8" : "#c5c5c5"}
        />
      </g>
    </svg>
  );
}
